export default "__VITE_ASSET__CUsBHsG7__"